<template>
  <validation-observer
    ref="form"
    #default="{ invalid }"
  >
    <b-modal
      :id="modalName"
      size="lg"
      ok-only
      no-close-on-backdrop
      @hidden="hideModal"
    >
      <template #modal-title="{}">
        <span>
          {{ isUpdated ? $t("Update") : $t("Create") }}
        </span>
        <span> {{ $t("Checkout") }}</span>
        <span v-if="isUpdated">{{ form.user.name }}</span>
      </template>
      <b-form>
        <b-row>
          <b-col
            md="6"
            cols="12"
          >
            <b-form-group
              :label="$t('Fee')"
            >
              <validation-provider
                #default="{ errors }"
                :name="$t('Fee')"
                vid="fee"
                rules="required"
              >
                <b-form-input
                  id="fee"
                  v-model="form.fee"
                  type="text"
                  :state="errors.length > 0 ? false : null"
                  :placeholder="$t('Fee')"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>
          <b-col
            md="6"
            cols="12"
          >
            <b-form-group :label="$t('Status')">
              <validation-provider
                #default="{ errors }"
                :name="$t('Status')"
                vid="status"
                rules="required"
              >
                <v-select
                  v-model="form.status"
                  :options="additionalData.statuses"
                  :clearable="false"
                  :reduce="_status => _status.key"
                  :state="errors.length > 0 ? false : null"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>
          <b-col
            cols="12"
          >
            <b-form-group :label="$t('Note')">
              <validation-provider
                #default="{ errors }"
                :name="$t('Note')"
                vid="note"
              >
                <b-form-textarea
                  id="note"
                  v-model="form.note"
                  :state="errors.length > 0 ? false : null"
                  :placeholder="$t('Note')"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>
        </b-row>

      </b-form>
      <template #modal-footer="{}">
        <b-button
          variant="success"
          :disabled="submitSpinner || invalid"
          @click="onSubmit"
        >
          <span>
            <b-spinner
              v-if="submitSpinner"
              small
            />
            {{ $t("Save") }}
          </span>
        </b-button>
        <b-button
          variant="info"
          :disabled="submitSpinner || invalid"
          @click="submitAndUpload"
        >
          <span>
            {{ $t("Save and submit bank receipt") }}
          </span>
        </b-button>
      </template>
    </b-modal>
  </validation-observer>
</template>

<script>
import { EditFormLayoutMixin, EditModalMixin } from '../../../common/mixins/form'

export default {
  name: 'CheckoutsEditModal',
  components: {
  },
  mixins: [EditFormLayoutMixin, EditModalMixin],
  data() {
    return {
      routeName: 'checkouts',
      modalName: 'modal-checkouts-edit',
      redirectAfterSubmit: false,
      createAbleFields: [
        'fee',
        'status',
        'note',
      ],
    }
  },
  methods: {
    submitAndUpload() {
      this.redirectAfterSubmit = true
      this.onSubmit()
    },
    afterEditFormSendSuccess() {
      this.$bvModal.hide(this.modalName)
      if (this.redirectAfterSubmit) {
        this.$router.push({ name: 'payments-show', params: { id: this.form.payment.id } }).then(() => {
          this.redirectAfterSubmit = false
        })
      }
    },
  },
}
</script>

<style scoped>

</style>
